import Joi from "joi";

const schema: any = Joi.object({
  email: Joi.string().required().email({
    tlds: false,
  }),
}).messages({
  "string.empty": "This field is required",
  "string.email": "Email is not valid",
});
export default schema;
